import React, { useState } from "react";
import { useParams } from "react-router-dom";
import atoms from "../../atoms";
import molecules from "../../molecules";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import service from "../../../api/services";
import {
    AddStaffProps,
} from "./interface";
import AddStaffForm from "./component/AddStaffForm";
import { staffValidationRules } from "./hook";

const { Button, Input } = atoms;
const { TopBar, CreateModal, PermissionAccordion } = molecules;

const AddStaff = ({
    setStaff,
    staff,
    setButtonClick,
    handleChangePassword,
    storeList,
    defaultPermission,
    subAdminPermission,
    _handleCheckboxChange,
    rolesList,
    handleSelectedRole,
    handleStorePermissionToggle,
}: AddStaffProps) => {
    const [errors, setErrors] = useState<any>({});
    const [createModal, setCreateModal] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [password, setPassword] = useState({
        newPassword: "",
        conformPassword: "",
        showPassword: false,
        showConformPassword: false,
    });
    let params = useParams();
    let staffEditID = params.id || "";

    const handleChange = (name: string, value: any) => {
        setStaff((prevState: any) => ({ ...prevState, [name]: value }));
        if (name !== "login_id") {
            setErrors((prevErrors: any) => ({ ...prevErrors, [name]: "" }));
        }
    };

    const validate = () => {
        let newErrors: Record<string, string> = {};
        for (const field in staffValidationRules) {
            if (staffValidationRules.hasOwnProperty(field)) {
                if (staffValidationRules[field]?.required && !staff[field]) {
                    newErrors[field] = "This field is required.";
                } else if (
                    staffValidationRules[field]?.label?.required &&
                    !staff[field]?.label
                ) {
                    newErrors[field] = "Please Select field";
                }
                if (
                    staffValidationRules[field].pattern &&
                    !staffValidationRules[field].pattern.test(staff[field])
                ) {
                    newErrors[field] = "Invalid format";
                }
                if (
                    staffValidationRules[field].minLength &&
                    staff[field].length < staffValidationRules[field].minLength
                ) {
                    newErrors[
                        field
                    ] = `Minimum length is ${staffValidationRules[field].minLength}`;
                }

                if (
                    staffValidationRules[field].maxLength &&
                    staff[field].length > staffValidationRules[field].maxLength
                ) {
                    newErrors[
                        field
                    ] = `Maximum length is ${staffValidationRules[field].maxLength}`;
                }
                if (
                    staffValidationRules[field].requiredLength &&
                    staff[field].length !== staffValidationRules[field].requiredLength
                ) {
                    newErrors[
                        field
                    ] = `Required length is ${staffValidationRules[field].requiredLength}`;
                }
                if (!staffEditID && !staff.password) {
                    newErrors.password = "This field is required.";
                }
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        const isValid = validate();
        if (isValid) {
            setButtonClick(true);
        }
    };
    const changePassword = () => {
        handleChangePassword(password?.newPassword);
        handleCloseModal();
    };

    const handleCloseModal = () => {
        setPassword({ ...password, newPassword: "", conformPassword: "" });
        setCreateModal(!createModal);
    };
    const _handleSearchUserID = async (userID: string) => {
        handleChange("login_id", userID.trim());
        try {
            const response = await service.store.searchUser(userID, {
                for_subadmin: true,
            });
            if (response.status === 200) {
                const login_id = response.data.data.login_id;
                if (login_id) {
                    setErrors((prevErrors: any) => ({
                        ...prevErrors,
                        login_id: "Existing User",
                    }));
                    handleChange("login_id", userID.trim());
                }
            }
        } catch (error: any) {
            if (error.response.status == 404) {
                setErrors({ ...errors, login_id: "" });
            }
        }
    };

    return (
        <div>
            <div className="row align-items-center mb-4">
                <div className="col-md-6 ">
                    <TopBar heading={staffEditID ? "Update" : "Add"} />
                </div>
            </div>

            <AddStaffForm
                staff={staff}
                _handleSearchUserID={(userID) => _handleSearchUserID(userID)}
                handleChange={handleChange}
                errors={errors}
                staffEditID={staffEditID}
                rolesList={rolesList}
                setCreateModal={setCreateModal}
                createModal={createModal}
                showPassword={showPassword}
                setShowPassword={setShowPassword}
                handleSelectedRole={handleSelectedRole}
            />

            <div className="row mt-3">
                {storeList?.map((item, index) => {
                    // Skip rendering if sub-admin permission is missing
                    if (!item?.showStore) return null;
                    return (
                        <div className="col-lg-6 mt-1" key={index}>
                            <PermissionAccordion
                                permissionLabel={item?.label}
                                handleStorePermissionToggle={(id: string, isChecked: boolean) =>
                                    handleStorePermissionToggle(id, isChecked)
                                }
                                storeID={item?.value}
                                structuredPermission={
                                    subAdminPermission &&
                                    subAdminPermission[item?.value]?.permission
                                }
                                defaultPermission={defaultPermission[item?.value]?.permission}
                                _handleCheckboxChange={(value: []) =>
                                    _handleCheckboxChange(value, item?.value)
                                }
                                isChecked={
                                    !!subAdminPermission[item?.value]?.isChecked || false
                                }
                            />
                        </div>
                    );
                })}
            </div>

            <div className="justify-content-center d-flex mt-4">
                <Button
                    name={staffEditID ? " Update Staff" : "Add Staff"}
                    className={"w-md-25"}
                    onClick={() => handleSubmit()}
                />
            </div>

            {createModal && (
                <CreateModal
                    show={createModal}
                    header={" New Password"}
                    handleSubmit={() => changePassword()}
                    buttonDisable={
                        !(password?.conformPassword == password?.newPassword) ||
                        !password.newPassword
                    }
                    submitBtnText={"Change Password"}
                    onHide={() => handleCloseModal()}
                >
                    <div>
                        <form>
                            <div className=" mt-25">
                                <div className="mt-4">
                                    <Input
                                        type={`${password?.showPassword ? "text" : "password"}`}
                                        className="form-control"
                                        placeholder="Enter Password"
                                        onChange={(e: any) =>
                                            setPassword({ ...password, newPassword: e.target.value })
                                        }
                                        // defaultValue={storeDetails.admin_change_password}
                                        label="New Password"
                                    />
                                    <span
                                        className="position-absolute cursor-pointer"
                                        style={{ top: "33%", right: "10%", fontSize: "20px" }}
                                        onClick={() =>
                                            setPassword({
                                                ...password,
                                                showPassword: !password?.showPassword,
                                            })
                                        }
                                    >
                                        {password?.showPassword ? (
                                            <AiOutlineEyeInvisible />
                                        ) : (
                                            <AiOutlineEye />
                                        )}
                                    </span>
                                </div>
                                <div className="mt-4">
                                    <Input
                                        type={`${password?.showConformPassword ? "text" : "password"
                                            }`}
                                        className="form-control"
                                        placeholder="Enter Password"
                                        onChange={(e: any) =>
                                            setPassword({
                                                ...password,
                                                conformPassword: e.target.value,
                                            })
                                        }
                                        // defaultValue={storeDetails.admin_change_password}
                                        label="Confirm Password"
                                    />
                                    <span
                                        className="position-absolute cursor-pointer"
                                        style={{ top: "75%", right: "10%", fontSize: "20px" }}
                                        onClick={() =>
                                            setPassword({
                                                ...password,
                                                showConformPassword: !password?.showConformPassword,
                                            })
                                        }
                                    >
                                        {password?.showConformPassword ? (
                                            <AiOutlineEyeInvisible />
                                        ) : (
                                            <AiOutlineEye />
                                        )}
                                    </span>
                                </div>
                            </div>
                        </form>
                    </div>
                </CreateModal>
            )}
        </div>
    );
};
export default AddStaff;
